import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokPage } from "@/storyblok";
import {
	type BlokProps,
	StoryblokComponent,
	StoryblokComponentList,
} from "@frend-digital/storyblok";
import styles from "./PageBlok.module.css";
import type { BaseSBType } from "@/types/storyblok-compat";

export const PageBlok = ({ blok, preview, ...rest }: BlokProps<BlokPage>) => {
	return (
		<BlokWrap asChild editable={blok} className={styles.root}>
			<main>
				{blok.header && (
					<StoryblokComponentList
						data-header
						{...rest}
						bloks={blok.header as BaseSBType[]}
						preview={preview}
					/>
				)}

				{!!blok.body &&
					blok.body.map((blok, index) => (
						<StoryblokComponent
							{...rest}
							index={index + 1}
							blok={blok as BaseSBType}
							key={(blok as BaseSBType)._uid}
							preview={preview}
						/>
					))}
			</main>
		</BlokWrap>
	);
};
